/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { Box } from '@mui/material';
import { Footer } from '../Footer/Footer';
import { ToggleColorMode } from '../ColorMode/ToggleColorMode';
import { NewSideBar } from '../Sidebar/NewSideBar';

const style = {
  display: 'flex',
  height: '100%',
  padding: '0 0 0 20px',
};

const boxContainerStyle = {
  display: 'flex',
  width: '100%',
  // height: "100%",
  borderRadius: '5px',
  bgcolor: 'background.paper',
  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
  justifyContent: 'center',
  overflow: 'hidden',
  mb: 3,
};

export const PageContainer = (props) => {
  return (
    <ToggleColorMode mode="dark">
      <div style={{ width: '100%', minHeight: '100vh', position: 'relative' }}>
        <Box sx={style}>
          <NewSideBar selectedPage={props.selectedPage} />
          <Box
            sx={{ display: 'flex', width: '100%', px: '28px', pt: 2.5, pb: 1 }}
          >
            <Box sx={boxContainerStyle}>
              <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
                {props.children}
              </Box>
            </Box>
          </Box>
        </Box>
        <Footer />
      </div>
    </ToggleColorMode>
  );
};
